<main class="app-spinner" [class.hide-me]="!isVisible">
  <div class="content">
    <div class="spinner"></div>
  </div>
</main>

